import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import StatusPill from 'components/Pills/StatusPills';

import styles from './InputGroup.module.scss';

export const InputGroup = ({
  title,
  description,
  tooltip,
  error,
  children,
  className,
  hidden = false,
  inline = false,
  strong = false,
  noMargin = false,
  optional = false,
}) => (
  <div
    className={cn(
      styles.root,
      {
        [className]: className,
        [styles.rootInline]: inline,
        'd-hide': hidden,
        [styles.rootNoMargin]: noMargin,
      },
      'input-group',
      { 'u-margin-bottom--0': noMargin },
    )}>
    {title && (
      <span
        className={cn(
          styles.title,
          {
            [styles.titleStrong]: strong,
            [styles.titleError]: error,
            [styles.titleNoMargin]: !!description,
          },
          'flex items-center gap-2',
        )}>
        {title}
        {tooltip && (
          <OverlayTrigger placement="bottom" overlay={<Tooltip>{tooltip}</Tooltip>}>
            <span className={styles.tooltip}>
              <FeatherIcon icon="info" />
            </span>
          </OverlayTrigger>
        )}
        {optional && <StatusPill text="Optional" status="neutral" />}
      </span>
    )}
    {description && (
      <span className="u-margin-bottom--small d-block t-tiny text-secondary">{description}</span>
    )}
    <div className={styles.input}>{children}</div>
  </div>
);

InputGroup.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  tooltip: PropTypes.string,
  error: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  inline: PropTypes.bool,
  strong: PropTypes.bool,
};
